import * as React from "react";
import * as ReactDOM from "react-dom";
import * as _ from "lodash";
import Button from "../ui/button/Button";

interface Props
{
    onCancel: () => void;
    onComplete: () => void;
    children: JSX.Element[];
}

interface State
{
    slide_index: number;
}

import './SlideShow.scss';

export class SlideShow extends React.Component<Props, State>
{
    constructor(public props: Props, public state: State)
    {
        super(props);

        this.state = { slide_index: 0 };
    }


    showNextSlide = () =>
    {
        const {slide_index:oindex} = this.state;

        const slide_index: number = oindex + 1;

        this.setState({slide_index});
    };

    showPreviousSlide = () =>
    {
        const {slide_index:oindex} = this.state;

        const slide_index: number = oindex - 1;

        this.setState({slide_index});
    };


    isFirstSlide = () : boolean =>
    {
        const {slide_index} = this.state;

        return slide_index === 0;
    };


    isLastSlide = () : boolean =>
    {
        const {children} = this.props;
        const {slide_index} = this.state;

        return slide_index === children.length - 1;
    };


    resetSlideShow = () =>
    {

    };


    cancelSlideShow = () =>
    {
        const {onCancel} = this.props;

        onCancel();
    };


    completeSlideShow = () =>
    {
        const {onComplete} = this.props;

        onComplete();
    };


    getSlides = () : JSX.Element[] =>
    {
        const {children} = this.props;
        const {slide_index} = this.state;

        return _.map(children, (child: JSX.Element, i: number) =>
        {
            return <div
                        styleName={'slide'}
                        style={{ transform: `translate(${(i - slide_index) * 100}%, 0)` }}
                        key={i}>

                {child}

            </div>
        });
    };


    render()
    {
        const {onCancel, onComplete} = this.props;

        const is_first_slide: boolean = this.isFirstSlide();
        const is_last_slide: boolean = this.isLastSlide();

        return <div styleName={'slideshow'}>

            <div styleName={'cancel-button-container'}>

                <Button
                    type={'slideshow-cancel'}
                    onClick={this.cancelSlideShow}>main menu</Button>

            </div>

            <div styleName={'slideshow-buttons-container'}>

                <span styleName={is_first_slide ? 'disabled-button' : ''}>

                    <Button
                        type={'slideshow-previous'}
                        onClick={this.showPreviousSlide}>back</Button>

                </span>

                {! is_last_slide &&
                <span styleName={'skip-button'}>

                    <Button
                        type={'slideshow-skip'}
                        onClick={onComplete}>skip</Button>

                </span>}

                {! is_last_slide &&
                <Button
                    type={'slideshow-next'}
                    onClick={this.showNextSlide}>next</Button>}

                {is_last_slide &&
                <Button
                    type={'slideshow-complete'}
                    onClick={this.completeSlideShow}>let's go!</Button>}

            </div>

            <div styleName={'slides'}>

                {this.getSlides()}

            </div>

        </div>
    }
}



// WEBPACK FOOTER //
// ./src/ts/app/common/slideshow/SlideShow.tsx